import { Box, Center, Loader, Stack } from '@mantine/core'
import { createFileRoute, Outlet, redirect, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { useBranchQuery } from '../api/branches/api'
import { useAuth } from '../auth-provider/auth-context'
import { TopBar } from '../components/app/components/topbar'
import { SupportModalProvider } from '../components/support-modal/SupportModalProvider'
import { setSentryUser } from '../sentry'
import { useUser } from '../user-provider/user-context'
import { prettyFullName } from '../utils/name'

export const Route = createFileRoute('/app')({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    if (!context.auth?.isAuthenticated) {
      throw redirect({
        to: '/login',
        // todo: add search parameters to the redirect url
      })
    }
    return {}
  },
})

function RouteComponent() {
  const navigate = useNavigate()
  const auth = useAuth()
  const { branchesLoading, branchInfo, user } = useUser()

  const { data: branch } = useBranchQuery(branchInfo?.provider_branch_id ?? '')

  useEffect(() => {
    if (!auth.isAuthenticated) {
      navigate({ to: '/login' })
    }
  }, [auth.isAuthenticated, navigate])

  useEffect(() => {
    setSentryUser(user, branch?.name ?? null)
    if (user && branch) {
      const name = prettyFullName(user.first_name, user.last_name)

      window.pylon = {
        chat_settings: {
          app_id: '0dba966f-34c6-4d4e-942c-f34bebf53027',
          email: user.email ?? 'N/A',
          name: name,
          shop_name: branch.name ?? 'N/A',
        },
      }

      if (window.Pylon && typeof window.Pylon.initialize === 'function') {
        window.Pylon.initialize()
      }
    }
  }, [user, branch])

  return (
    <Stack gap={0} h="100vh" style={{ overflow: 'hidden' }}>
      <SupportModalProvider>
        <TopBar />
        <Box style={{ flexGrow: 1, flexShrink: 1, overflow: 'auto' }} mih={0}>
          <InnerContainer loading={branchesLoading} />
        </Box>
      </SupportModalProvider>
    </Stack>
  )
}

function InnerContainer({ loading }: { loading: boolean }) {
  if (loading) {
    return (
      <Center mih="400px">
        <Loader />
      </Center>
    )
  }
  return <Outlet />
}
